import { makeStyles } from 'makeStyles';

export const useStyles = makeStyles()(() => ({
  eventLink: {
    fontWeight: 'normal',
    textDecoration: 'none',
    cursor: 'pointer',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
}));
